/**
 * Onboard shell — the signed-out screens.
 *
 * Two columns: a navy panel carrying the product's pitch, and the form centred on the right. The
 * panel collapses away below 900px so the form gets the whole viewport on a phone.
 *
 * @module Templates/Onboard
 */

import type { JSX, ReactNode } from 'react';
import {
  Brand,
  BrandMark,
  BrandName,
  ContentContainer,
  Headline,
  LeftPanel,
  MainContainer,
  PanelFooter,
  Pitch,
  RightPanel,
} from './Onboard.template.style';

export interface OnboardTemplateProps {
  children: ReactNode;
}

const OnboardTemplate = ({ children }: OnboardTemplateProps): JSX.Element => (
  <main className={MainContainer}>
    <section className={LeftPanel}>
      <div className={Brand}>
        <span className={BrandMark}>GL</span>
        <span className={BrandName}>BFF Apps</span>
      </div>

      <div>
        {/*
          It used to open with "Administração do BFF" — architecture jargon, above a brand mark
          that already reads "BFF Apps" — and then claimed every publication passes through a
          second person, which stopped being true when whats_new:approve_own shipped.
        */}
        <h1 className={Headline}>Administração das business units.</h1>
        <p className={Pitch}>Anúncios, tours, páginas e assinaturas de e-mail.</p>
      </div>

      <span className={PanelFooter}>GroupLink One</span>
    </section>

    <section className={RightPanel}>
      <div className={ContentContainer}>{children}</div>
    </section>
  </main>
);

export { OnboardTemplate };
